import React from 'react';
import {Trans} from 'react-i18next';
import {Tab, Tabs} from 'react-bootstrap';

export default function TabSec({tab, setTab}) {
  const tabConfig = [
    {
      key: 'SmbSimulationResultPage',
      title: (
        <Trans i18nKey="p.s.uiconfiguration.simulation.report">
          Simulation Report Page
        </Trans>
      ),
    },
    {
      key: 'SmbSimulationGetResultPage',
      title: (
        <Trans i18nKey="p.s.uiconfiguration.getsimulationreportpage.title">
          Get Simulation Report Page
        </Trans>
      ),
    },
  ];

  return (
    <Tabs
      id="dashboard-config"
      className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand m-0"
      defaultActiveKey="SmbSimulationResultPage"
      onSelect={key => setTab(key)}
      activeKey={tab}
      unmountOnExit={true}
    >
      {tabConfig.map(config => (
        <Tab
          key={config.key}
          className="nav-link"
          eventKey={config.key}
          title={config.title}
        />
      ))}
    </Tabs>
  );
}
